import { Component, inject, Input, OnInit } from '@angular/core';
import { LoggerService } from 'src/app/services/logger.service';

@Component({
  selector: 'app-badge-svg',
  templateUrl: './badge-svg.component.html',
  styleUrls: ['./badge-svg.component.scss'],
})
export class BadgeSvgComponent implements OnInit {
  @Input() badgeId: number;
  @Input() active: boolean;
  @Input() activation: number;

  readonly logger = inject(LoggerService);

  ngOnInit() {
    if (this.activation < 0 || this.activation > 100) {
      this.logger.warn("'Activation' must be set to a value between 0 and 100");
    }
  }
}
